import CloseIcon from '@mui/icons-material/Close';
import CopyIcon from '@mui/icons-material/ContentCopy';
import { Box, FormControl, IconButton, InputAdornment, OutlinedInput } from "@mui/material";
import { FC, useState } from 'react';
import { copyTextToClipboard } from '../../common/helpers';
import { Shift } from './Helpers';
import { cmToIn, inToCm } from './UnitComponents';

interface IProps {
    onClose(): void
}

const InchCalculator: FC<IProps> = props => {

    const [x, setX] = useState(0)
    const [y, setY] = useState(10)


    const onMouseMove = (event: MouseEvent) => {
        event.preventDefault()
        event.stopPropagation()
        // console.log(event)

        setX(event.x)
        setY(event.clientY - 48 * 2)
    }

    const onMouseDown = (event: any) => {
        event.preventDefault()
        event.stopPropagation()
        window.addEventListener('mousemove', onMouseMove)
        window.onmouseup = onMouseUp


    }

    const onMouseUp = (event: MouseEvent) => {
        event.preventDefault()
        event.stopPropagation()
        window.removeEventListener('mousemove', onMouseMove)
        window.onmouseup = null
    }

    const [cmValue, setCmValue] = useState(0)
    const [inValue, setInValue] = useState(0)

    const copyCm = () => {
        copyTextToClipboard(cmValue.toString())
    }

    const copyIn = () => {
        copyTextToClipboard(inValue.toString())
    }

    return (
        <Box
            sx={{
                position: "absolute",
                left: x !== 0 ? x : undefined,
                right: x === 0 ? 10 : undefined,
                top: y,
                border: '1px solid',
                borderColor: (theme) => theme.palette.grey[500],
                borderRadius: 1,
                width: 200,
            }}
        >
            <Box
                onMouseDown={onMouseDown}
                sx={{
                    cursor: 'move',
                    borderBottom: '1px solid',
                    borderColor: (theme) => theme.palette.grey[500],
                    display: 'flex'
                }}
            >
                <Shift />
                <IconButton
                    onClick={props.onClose}
                    sx={{
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>

            <Box p={2}>


                <FormControl variant="outlined" size='small' sx={{ flexGrow: 1 }}>
                    <OutlinedInput
                        style={{}}
                        type='number'
                        value={cmValue}
                        onChange={(e) => {
                            let newValue = parseFloat(e.target.value)

                            setCmValue(newValue)
                            setInValue(cmToIn(newValue))
                        }}
                        onFocus={e => e.target.select()}
                        startAdornment={<InputAdornment position="start">cm</InputAdornment>}
                        endAdornment={<InputAdornment position="end">
                            <CopyIcon sx={{
                                color: (theme) => theme.palette.grey[500],
                                cursor: 'pointer'
                            }}
                                onClick={copyCm}
                            /></InputAdornment>}
                    />
                </FormControl>


                <FormControl variant="outlined" size='small' sx={{ mt: 2 }}>
                    <OutlinedInput
                        style={{}}
                        type='number'
                        value={inValue}
                        onChange={(e) => {
                            let newValue = parseFloat(e.target.value)

                            setInValue(newValue)
                            setCmValue(inToCm(newValue))
                        }}
                        onFocus={e => e.target.select()}
                        startAdornment={<InputAdornment position="start">in</InputAdornment>}
                        endAdornment={<InputAdornment position="end"> <CopyIcon sx={{
                            color: (theme) => theme.palette.grey[500],
                            cursor: 'pointer'
                        }}
                            onClick={copyIn}
                        /></InputAdornment>}
                    />
                </FormControl>

            </Box>
        </Box>
    )
}

export default InchCalculator